export const THEMES = [
  { id: "obsidian-crimson", name: "Obsidian Crimson", description: "Premium dark with a restrained crimson glow." },
  { id: "rosewater", name: "Rosewater", description: "Soft blush and lavender with readable plum text." },
  { id: "sky-cloud", name: "Sky & Cloud", description: "Airy cloud surfaces with clear sky-blue accents." },
  { id: "sage-sand", name: "Sage & Sand", description: "Warm ivory, sage and grounded charcoal." },
];

export const DEFAULT_THEME = "obsidian-crimson";
export const THEME_STORAGE_KEY = "hacams.appearance.theme";

export function resolveTheme(value) {
  return THEMES.some((theme) => theme.id === value) ? value : DEFAULT_THEME;
}

function browserStorage() {
  try { return globalThis.localStorage; } catch { return null; }
}

export function readThemePreference(storage) {
  try {
    const target = storage === undefined ? browserStorage() : storage;
    return resolveTheme(target?.getItem(THEME_STORAGE_KEY));
  } catch {
    return DEFAULT_THEME;
  }
}

export function saveThemePreference(value, storage) {
  const theme = resolveTheme(value);
  try {
    const target = storage === undefined ? browserStorage() : storage;
    target?.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // Storage can be unavailable in private or locked-down browsing contexts.
  }
  return theme;
}

export function applyThemePreference(theme, documentRef = globalThis.document) {
  if (!documentRef?.documentElement) return;
  const selected = resolveTheme(theme);
  documentRef.documentElement.dataset.hacamsTheme = selected;
  documentRef.documentElement.style.colorScheme =
    selected === "rosewater" || selected === "sky-cloud" || selected === "sage-sand" ? "light" : "dark";
}
